var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1670_559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.74976H0.75C0.335786 8.74976 0 9.08554 0 9.49976C0 9.91398 0.335786 10.2498 0.75 10.2498H17.25C17.6642 10.2498 18 9.91398 18 9.49976C18 9.08554 17.6642 8.74976 17.25 8.74976Z",
    fill: "#004E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 3.50024H0.75C0.335786 3.50024 0 3.83603 0 4.25024C0 4.66446 0.335786 5.00024 0.75 5.00024H17.25C17.6642 5.00024 18 4.66446 18 4.25024C18 3.83603 17.6642 3.50024 17.25 3.50024Z",
    fill: "#004E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 14H0.75C0.335786 14 0 14.3358 0 14.75C0 15.1642 0.335786 15.5 0.75 15.5H17.25C17.6642 15.5 18 15.1642 18 14.75C18 14.3358 17.6642 14 17.25 14Z",
    fill: "#004E60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1670_559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.2d1e70453ff8a884c86264e2f6873081.svg";
export { ForwardRef as ReactComponent };